<template>
    <div class="auth-wrapper registration">
        <div v-if="!isMobile" class="auth-wrapper auth-wrapper-left"></div>

        <div class="auth-wrapper-rigth">
            <div class="auth-wrapper__content">
                <div class="auth-wrapper__logo logo">
                    <figure class="figure-logo">
                        <img src="/static/logos/logo_dv7.png" alt="40%" width="80%">
                    </figure>
                </div>
                <el-form
                    :model="model"
                    :rules="rules"
                    ref="form"
                    label-position="left"
                    label-width="0px"
                    :class="{'login-container': !isMobile, 'login-container-mobile': isMobile}"
                    @submit.native.prevent
                >
                    <el-form-item prop="email">
                        <el-input
                            :disabled="!!defaultEmail"
                            type="text"
                            v-model="model.email"
                            @keyup.enter.native="submit"
                            auto-complete="off"
                            placeholder="Email"
                            ref="focus"
                        ></el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input
                            type="password"
                            v-model="model.password"
                            @keyup.enter.native="submit"
                            auto-complete="off"
                            placeholder="Password"
                        ></el-input>
                    </el-form-item>
                    <el-form-item style="width:100%;">
                        <el-button
                            type="primary"
                            style="width:100%;"
                            @click="submit"
                            :loading="loading"
                        >Create account</el-button>
                    </el-form-item>
                    <el-form-item class="text-center">
                        <router-link :to="{ name: 'login' }">Cancel</router-link>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import validators from "@/shared/form/validators";

export default {
    name: "app-registration",

    data() {
        return {
            rules: {
                email: validators.string({
                    label: "Email",
                    required: true,
                    min: 1
                }),
                password: validators.string({
                    label: "Password",
                    required: true,
                    max: 255
                })
            },
            model: {}
        };
    },

    computed: {
        ...mapGetters({
            loading: "auth/loading",
            isMobile: "shared/isMobile"
        }),

        defaultEmail() {
            return this.$route.query.email || null;
        }
    },

    created() {
        if (this.defaultEmail) {
            this.model.email = this.defaultEmail;
        }
    },

    methods: {
        submit() {
            this.$refs.form.validate().then(valid => {
                if (!valid) {
                    return;
                }

                this.$store
                    .dispatch("auth/register", {
                        email: this.model.email,
                        password: this.model.password
                    })
                    .then(() => {
                        this.$router.push("/");
                    });
            });
        }
    }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/auth/registration/registration.vue?3ebaa817